import ImportACHPage from "components/pages/ImportACHPage";

export default function CaptureParticipantImport(props) {
    return <ImportACHPage/>;
}